import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RJobOverallAssessment } from './r-job-overall-assessment.action';

interface RJobOverallAssessmentXsStateModel {
  viewJobOverallAssessment: string;
  createJobOverallAssessment: string;
  editJobOverallAssessment: string;
  deleteJobOverallAssessment: string;

}

const getDefaults = (): RJobOverallAssessmentXsStateModel => ({
  viewJobOverallAssessment: null,
  createJobOverallAssessment: null,
  editJobOverallAssessment: null,
  deleteJobOverallAssessment: null

});

@State<RJobOverallAssessmentXsStateModel>({
  name: 'rJobOverallAssessment',
  defaults: getDefaults()
})
@Injectable()
export class RJobOverallAssessmentXsState {

  //region SELECTOR
  @Selector()
  static canViewJobOverallAssessment(state: RJobOverallAssessmentXsStateModel): boolean {
    return state.viewJobOverallAssessment != null;
  }

  @Selector()
  static canCreateJobOverallAssessment(state: RJobOverallAssessmentXsStateModel): boolean {
    return state.createJobOverallAssessment != null;
  }

  @Selector()
  static canEditJobOverallAssessment(state: RJobOverallAssessmentXsStateModel): boolean {
    return state.editJobOverallAssessment != null;
  }

  @Selector()
  static canDeleteJobOverallAssessment(state: RJobOverallAssessmentXsStateModel): boolean {
    return state.deleteJobOverallAssessment != null;
  }

  //endregion

  //region ACTIONS
  @Action(RJobOverallAssessment.SetJobOverallAssessmentPrivileges)
  public setJobOverallAssessmentPrivileges(ctx: StateContext<RJobOverallAssessmentXsStateModel>, action: RJobOverallAssessment.SetJobOverallAssessmentPrivileges) {
    const state = ctx.getState();
    const designationPrivileges = [...action.activeUserRightInfoDtoModel.designationPrivileges];

    //find user privilege data model
    const viewJobOverallAssessment = designationPrivileges.find(id => id === UserPrivilegeEnum.VIEW_JOB_OVERALL_ASSESSMENT);
    const createJobOverallAssessment = designationPrivileges.find(id => id === UserPrivilegeEnum.CREATE_JOB_OVERALL_ASSESSMENT);
    const editJobOverallAssessment = designationPrivileges.find(id => id === UserPrivilegeEnum.EDIT_JOB_OVERALL_ASSESSMENT);
    const deleteJobOverallAssessment = designationPrivileges.find(id => id === UserPrivilegeEnum.DELETE_JOB_OVERALL_ASSESSMENT);

    //set the state
    ctx.setState({
      ...state,
      viewJobOverallAssessment: viewJobOverallAssessment,
      createJobOverallAssessment: createJobOverallAssessment,
      editJobOverallAssessment: editJobOverallAssessment,
      deleteJobOverallAssessment: deleteJobOverallAssessment
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RJobOverallAssessmentXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
}
